import React from "react";
import styles from "./styles.module.css";
import moment from "moment";
import Tooltip from "../../../Tooltip/Tooltip";
import { LuInfo } from "react-icons/lu";
const HistoryCollapseHeader = ({ status, lastChannel, dateTime }) => {
  return (
    <div className={styles["purpose-history-content"]}>
      <div className={styles["details-container"]}>
        <p className={styles["purpose-status"]}>Purpose : {status}</p>
        {lastChannel && (
          <p className={styles["last-update"]}>
            Last update channel: {lastChannel}
          </p>
        )}
      </div>
      {dateTime && (
        <div className={styles["info-date-time"]}>
          <p className={styles["purpose-last-update"]}>
            {moment.utc(dateTime).local().format("DD.MM.YYYY HH:mm")}
          </p>
          <Tooltip
            position="right"
            text={`${moment.utc(dateTime).format("DD.MM.YYYY HH:mm")} UTC`}
          >
            <LuInfo className="date__icon__more__info" />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default HistoryCollapseHeader;
